import styled from 'styled-components'

import { Skeleton } from '../skeleton'

import type { ClassNameProps } from '@root/shared/react'

type UnderlineTabsSkeletonProps = ClassNameProps & {
  tabsCount?: number
}

export const UnderlineTabsSkeleton: React.FC<UnderlineTabsSkeletonProps> = ({
  className,
  tabsCount = 3,
}) => (
  <Root className={className}>
    {Array.from({ length: tabsCount }).map((_, index) => (
      <Tab key={index}>
        <Skeleton width={Skeleton.between(64, 96)} height={12} />
      </Tab>
    ))}
  </Root>
)

const Root = styled.div`
  display: grid;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  position: relative;
  gap: var(--tabs-gap, 0);
  border-bottom: 2px solid rgba(0, 0, 0, 0.32);
`

const Tab = styled.div`
  display: grid;
  place-items: center;
  height: var(--tab-height, 38px);
  padding-inline: var(--tab-padding-inline, 15px);
`
